"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessageAndImmediatelyExecute = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = exports.EGeneralCommand = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var voyageGameManager_sidecar_1 = require("@voyage/game-status/voyageGameManager-sidecar");
var voyageMessageIds_1 = require("./voyageMessageIds");
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var EGeneralCommand;
(function (EGeneralCommand) {
    EGeneralCommand[EGeneralCommand["Pause"] = 0] = "Pause";
    EGeneralCommand[EGeneralCommand["Unpause"] = 1] = "Unpause";
})(EGeneralCommand = exports.EGeneralCommand || (exports.EGeneralCommand = {}));
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.GeneralCommand;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    messageWriter_sidecar_1.messageWriter.write8(m, d.command);
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        command: messageWriter_sidecar_1.messageWriter.read8(m),
    };
    return d;
}
exports.read = read;
function test() {
    var ex = {
        command: EGeneralCommand.Unpause,
    };
    messageWriter_sidecar_1.messageWriter.test('general-command', ex, write, read);
}
exports.test = test;
function process(m) {
    var msg = read(m);
    if (msg.command === EGeneralCommand.Pause) {
        voyageGameManager_sidecar_1.voyageGameManager.networkPause(true);
    }
    if (msg.command === EGeneralCommand.Unpause) {
        voyageGameManager_sidecar_1.voyageGameManager.networkPause(false);
    }
}
exports.process = process;
function sendMessageAndImmediatelyExecute(msg) {
    websockets_sidecar_1.websockets._sendMessageAndImmediatelyExecute(write, msg);
}
exports.sendMessageAndImmediatelyExecute = sendMessageAndImmediatelyExecute;
